module.exports = __webpack_public_path__ + "img/tests2.aed01355.png";